// extracted by mini-css-extract-plugin
export var carrierIconPlaceholder = "_9q-1";
export var dragButton = "_9q-5";
export var sortableCell = "_9q-4";
export var sortableNameCell = "_9q-3";
export var sortableRow = "_9q-0";
export var tableHeader = "_9q-6";
export var tableHeaderWithCardHeader = "_9q-7";
export var weightInputRow = "_9q-2";